import {ref} from "vue";

export function useStages() {
    const createStages = ref([
        {
            stage: 'SOURCE',
            index: 1,
            isVisible: true,
            label: "Источник",
            description: "Выберите источник",
            isSkipped: false,
            isFocused: true,
            isSelected: false,
        },
        {
            stage: 'DATA_PROCESSOR',
            index: 2,
            isVisible: false,
            label: "Обработка",
            description: "Обработка данных",
            isSkipped: false,
            isFocused: false,
            isSelected: false,
        },
        {
            stage: 'TARGET',
            index: 3,
            isVisible: false,
            label: "Назначение",
            description: "Выберите таблицу назначения",
            isSkipped: false,
            isFocused: false,
            isSelected: false,
        },
    ])
    const currentStage = ref(createStages.value[0])

    return {
        createStages,
        currentStage,
    }
}